import { z } from 'zod';
import { slugSchema } from './setup/slug';

// ---------------------------------------------------------------------------
// State Operations (via state_operations RPC)
// ---------------------------------------------------------------------------

export const stateOperationBody = z.object({
  hub_id: z.string().uuid(),
  operation: z.enum(['get', 'update', 'set_path', 'reset']),
  state_slug: slugSchema,
  /**
   * Deprecated and ignored. Scope is derived from the hub's state definition.
   * Kept on the schema so legacy bodies still validate.
   */
  state_scope: z.enum(['conversation', 'user']).optional(),
  updates: z.record(z.unknown()).optional(),
  path: z.array(z.string()).optional(),
  value: z.unknown().optional(),
});

export interface StateOperationResponse {
  ok: true;
  data: unknown;
}
